import React from 'react';
import Header from '../components/Header';
import HomeContent from '../components/HomeContent';
import Footer from '../components/Footer'

function Home() {
  return (
    <>
      {/* <Header /> */}
      <HomeContent />
      <Footer/>
    </>
  )
}

export default Home